import { Inject, inject, Injectable } from '@angular/core';
import { Store } from '@sama/app-state';
import { isNil, size } from '@sama/micro-dash';
import { isUndefined } from 'lodash';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { ShapeState } from '../../../../../cross-team-shared/annotation/shared/state/shape-state';
import { selectionToArray } from '../../../../../cross-team-shared/misc-utils';
import {
  OutputInfo,
  outputInfoStoreToken,
} from '../../../../h3ml/state/output-info';
import { TaskWorkspaceStore } from '../../../../h3ml/state/task-workspace-store';
import { ShapeSelectionService } from './shape-selection.service';

@Injectable()
export class ObjectlessFocusedShapeService {
  private selectionService = inject(ShapeSelectionService);
  private shapesStore: Store<ShapeState[]>;

  constructor(
    @Inject(outputInfoStoreToken) outputInfoStore: Store<OutputInfo>,
    taskWorkspaceStore: TaskWorkspaceStore,
  ) {
    // for some obscure reason, it's impossible to inject shapeInfoStoreToken in
    // this service
    this.shapesStore = taskWorkspaceStore('outputAnnotationInfo')(
      outputInfoStore.state().output.name,
      // @ts-ignore -- fix me
    )('shapes');
  }

  getFocusedShapeIndex() {
    const selection = this.selectionService.getSelectionForOutput();
    if (size(selection) !== 1) {
      return undefined;
    }
    return selectionToArray(selection)[0];
  }

  getFocusedShapeStore() {
    const selectedIndex = this.getFocusedShapeIndex();
    if (isUndefined(selectedIndex)) {
      return undefined;
    }
    return this.shapesStore(selectedIndex);
  }

  getFocusedShapeStore$(): Observable<Store<ShapeState> | undefined> {
    // @ts-ignore -- fix me
    return this.selectionService.getSelectionForOutput$().pipe(
      map(() => this.getFocusedShapeStore()),
      distinctUntilChanged((prev, curr) => {
        if (isNil(prev) && isNil(curr)) {
          return true;
        }
        if (isNil(prev) || isNil(curr)) {
          return false;
        }
        return prev.refersToSameStateAs(curr);
      }),
    );
  }
}
